module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "chap-002"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_tit"
  }, [_c('span', [_vm._v("PAUL’S DESIRE TO VISIT ROME"), _c('br'), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Romans+1:8-13&version=RSV",
      "target": "_blank"
    }
  }, [_vm._v("ROMANS 1:8-13")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERVIEW")]), _vm._v(": ")]), _vm._v("The Fathers noted the praise Paul heaped on the Romans and contrasted it favorably with what he said about some of the other churches he wrote to. They were well aware of Rome’s importance as the imperial capital and assumed that the reputation of the Roman church had spread across the world because of the city’s central political position. Paul longed to visit Rome, but his prayers had so far gone unanswered. Unanswered prayer is an age-old spiritual problem which the Fathers resolved by saying that the real prayer of the Christian is to be conformed to God’s will. Specific requests might be granted, as in the case of Balaam, but if they were not in the wider purpose of God, they were sure to turn out badly.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Paul’s emphasis on the spiritual nature of his own Christian service made a deep impression on the Fathers, who used it as a model for all believers. The spiritual gift Paul desired to give to the Romans was to lead them beyond bondage to the law and into salvation by faith alone. Paul was not coming to Rome to impart new teaching, nor did he wish to lord it over the church. His inten"), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("tions were both humble and heartwarming, as he desired no more than to share with the Romans and be encouraged by them even as he taught them more of the truth. God’s plans for Paul’s life overruled the apostle’s own desires, which is why he had been prevented from going to Rome. The Fathers emphasized this point much more than Paul’s desire to do good when he got there, though that was occasionally mentioned as well. Once more we see the great interest they had in the cosmic ordering of the universe, next to which our individual thoughts and desires count for nothing.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-017"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('span', {
    staticClass: "r"
  }, [_c('i', [_vm._v("1:8 ")]), _vm._v("The Faith Proclaimed")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HROUGH ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESUS ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST.")])]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("Sometimes the apostle writes in the way he does to the Romans, giving thanks for everyone, but sometimes he just gives thanks without adding “for all of you.” If you notice this you will realize that in the places where he gives thanks for everyone, he does not draw attention to any grave faults or sins in them. But where he criticizes people or reproves them, he does not add to his thanksgiving that he gives thanks for them all—see, e.g., 1 Corinthians or Colossians.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN151",
      "id": "ap_NFIN151-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" In Galatians he does not even give thanks at all, because he is surprised that they have so quickly abandoned the gospel that called them and chosen another one instead."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN152",
      "id": "ap_NFIN152-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Paul thus begins his letter with thanksgiving. To give thanks to God is to offer him a sacrifice of praise, and therefore he adds “through Jesus Christ,” as through a high priest. Anyone who wants to offer a sacrifice to God ought to know that he should offer it through the hands of a priest. But note also this important addition: “(to) my God.” This can only be the voice of the saints, whose God he is, as he is the God of Abraham, Isaac and Jacob. No one can say that the Lord God is his if his god is his stomach, or if his god is greed, or if his god is the glory of this life and the pomp of this world or the power of things which are perishing. For whatever anyone worships more than other things, that is his god.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But let us see what it is that the apostle gives thanks for. “Because,” he says, “your faith is proclaimed in all the world.” “In all the world,” simply understood, means that in many parts of the world, that is of this earth, the faith and religion of those at Rome is preached. But if, as in some passages, the universe is meant here, consisting of heaven and earth and everything in them, it may be understood to mean that the powers, of whom it is said that “they rejoice over one sinner who repents,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN153",
      "id": "ap_NFIN153-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" rejoice much more over the conversion and the faith of the Romans when the angels who ascend and descend to the Son of Man"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN154",
      "id": "ap_NFIN154-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" proclaim it to them. For these powers are amazed at the conversion of the Gentiles and that the sound of the apostles of Christ Jesus has gone out into all the world. Finally, they rejoice even at the sufferings of those in this world, as the apostle says: “We have become a spectacle to the world, to angels and to men.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN155",
      "id": "ap_NFIN155-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The verse may also be understood as meaning that this faith which the Romans have is the same faith as, and none other than, that which is proclaimed and believed in all the world and which is preached not only on earth but in heaven as well. For by his blood Jesus reconciled not only those things which are on earth but also those things which are in heaven, and in his name not only earthly powers but also heavenly and infernal ones bow the knee. This is what is meant by preaching the faith in the whole world, through which the entire earth may be subjected to God.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It may be noticed that there is no “second” which corresponds to “first,” but we have already explained that Paul’s phrases are not always complete. On the other hand, it may be that “first” is picked up by “I want you to know brethren” [in verse 13]. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN156",
      "id": "ap_NFIN156-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH OF THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH AT ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OME.")])]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVA")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TIAN: ")]), _vm._v("We have not just recently adopted this particular course of action, nor have these measures against the ungodly suddenly crossed our mind. For with us, the strictness is ancient, the faith is ancient. The apostle would not have praised us so highly by stating: “Your faith is spoken of throughout the whole world,” if this strictness of ours had not already been rooted in the faith of those times. L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NE 2.2.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN157",
      "id": "ap_NFIN157-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROCLAIMED ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LL OVER THE ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORLD.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YPRIAN: ")]), _vm._v("This counsel was not recently planned by us, nor have these unexpected protections against the wicked lately surprised us. But this is read of among us as the ancient severity, the ancient faith, the ancient discipline, since the apostle would not have revealed so great praise of us when he said: “because your faith is proclaimed all over the world,” if already this vigor had not borrowed the roots of faith from those times; it is a very great crime to have been unworthy of these praises and of glory. L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER 30.2.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN158",
      "id": "ap_NFIN158-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONSPICUOUS ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLE OF ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OME. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("After finishing his introduction, before all else Paul bears witness to his joy, as the apostle to the Gentiles, that although the Romans ruled the world, they had submitted to the Christian faith, which seemed lowly and stupid to the wise of this world. There were many things about the Romans which he could rejoice in. They were mindful of discipline and eager to do good works, more interested in doing right than in talking about it, which is not far from God’s religion. Nevertheless, he says that most of all he rejoices in this, that word of their faith was circulating everywhere. For it seemed to be a wonderful thing, that the lords of the Gentiles should bow before a promise made to the Jews. Even if they did not believe correctly, nevertheless he was pleased that they had begun to worship one God in the name of Christ, and knew that they could advance further. For this reason he reveals his love for them, when he rejoices at their good start and encourages them to go on. He therefore says that he is giving thanks to God, even though they have not yet received everything, because God is the source of all things. The entire dispensation of our salvation is from God, indeed, but through Christ, not through the law or any prophet. Hence he says that he is giving thanks to God but through Christ, because the report of their faith was an encouragement to many to attribute this very thing to the providence of God through Christ. For either the others who believed rejoiced, having been strengthened by seeing their rulers and brothers established in the faith, or at least those who did not believe could easily have believed by following their example. For the lesser quickly does what he sees being done by the greater. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN159",
      "id": "ap_NFIN159-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLLOWING IN ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETER’S ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOTSTEPS.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORE OF ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OPSUESTIA: ")]), _vm._v("It seems that Paul begins by giving thanks in his other epistles too, thereby teaching by word and deed those to whom the letter is written that one ought to begin by thanking God, not only for one’s own but also for others. But here this salutation has a special importance, because after the teaching of Peter, anyonewho wanted to teach them the doctrines of godliness had to show that he accepted Peter’s teaching and was not trying to introduce them to anything which went against that. Therefore his praise of the Romans was no accident. Often in his letters he used the salutation as a way of preparing those who would be better disposed toward him as a result of such praise, for the reading of what had been written.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Through Jesus Christ” had to be added here, not to qualify Christ’s ministry, as it seemed to some of the heretics, but because he is the cause of our thanks. Hence the apostle says that he thanks God for them all and that Christ is the cause of his thanksgiving. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AULINE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY FROM THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN160",
      "id": "ap_NFIN160-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLDNESS IN ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARRYING THE ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERYWHERE.")])])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("Paul bears witness to two excellencies in the Romans—one, that they believed, and two, that they believed with boldness, and with boldness so great that their reputation spread throughout the world. It was their faith, not their verbal disputations, nor their questionings, nor their syllogisms which he remarked upon. And yet there were many hindrances to their teaching. For having recently acquired a worldwide empire the Romans were elated, and they lived in riches and luxury, and then fishermen brought the preaching there, Jewish fishermen moreover, who belonged to a nation which was hated and despised by everyone. And these Romans were asked to worship the crucified one who was brought up in Judea. Moreover, along with this doctrine, the teachers proclaimed an ascetic life to men who were used to luxury and concerned with material comforts. Those who proclaimed the gospel were poor and common men of no notable family, and born to those of no family. But none of these things hindered the progress of the Word, so great was the power of the crucified to carry the Word everywhere. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS 2.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN161",
      "id": "ap_NFIN161-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH OF THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")])]), _c('span', {
    staticClass: "small"
  }, [_vm._v(" [")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SEUDO-]")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONSTANTIUS: ")]), _vm._v("Paul shows that the faith of the Romans is known to all the churches or at least that the same faith which the Romans hold is preached throughout the world by the apostles. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLY ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER OF ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("T. ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN162",
      "id": "ap_NFIN162-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORLD ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MAZED.")])]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIUS: ")]), _vm._v("God is the God of all by nature but of some only by their own choice and response. . . . Paul calls God his in this second sense. He thanks God for them all, not just for the Jews, and praises them prudently, in order to encourage them to improve. Perhaps he did this because the whole world stood amazed that the idolatrous Romans had been converted . . . but probably he was just praising a faith which was now evident. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIUS’S ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN163",
      "id": "ap_NFIN163-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NOWN ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HROUGHOUT THE ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORLD.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YR: ")]), _vm._v("Paul was not saying this in order to flatter them; he was simply telling the truth. For it could not be that what was happening at Rome should not be known all over the world. After all, it was the capital of the empire. I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTERPRETATION OF THE ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN164",
      "id": "ap_NFIN164-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL AND THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMAN ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH.")])]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENNADIUS OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONSTANTINOPLE: ")]), _vm._v("Paul does not say “through Jesus Christ” as if he were some kind of intermediary, but in the context of giving thanks to God, says that we do this because of the Lord Christ. This amazing dispensation which has saved our race through him has taken us captive, along with the rest, by the faith we have in him.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Paul does his utmost to win the Romans over, in case they may be thinking that he has something against them, or that following the tradition of Peter he might be coming to order them about, and if indeed they are vexed for this sort of reason, they might refuse to read his letter and miss out on the blessing it would bring. Therefore, starting with thanksgiving and faith, he praised them for keeping it pure and firm, as they all did together, and then with the word "), _c('i', [_vm._v("proclaimed")]), _vm._v(" spoke more personally in praise of the city, and by adding “in all the world” he praised them greatly and exalted them before going on to talk about meeting them in person. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AULINE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY FROM THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN165",
      "id": "ap_NFIN165-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-018"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('span', {
    staticClass: "r"
  }, [_c('i', [_vm._v("1:9")]), _vm._v(" Service in the Spirit")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OU ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILL ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("Y ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITNESSES.")])]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("God is witness for his saints, because they also are witnesses for God according to the word of the prophet Isaiah: “You will be my witnesses and I am a witness, says the Lord.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN166",
      "id": "ap_NFIN166-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" The Savior also says to his disciples: “You will be my witnesses in "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Jerusalem, in Samaria and even to the ends of the earth,”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN167",
      "id": "ap_NFIN167-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" according to what is written: “Everyone who acknowledges me before men, I will also acknowledge before my Father.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN168",
      "id": "ap_NFIN168-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Let us consider what Paul means when he says: “Whom I serve with my spirit.” It seems to me that to serve in spirit is both similar to but also much more than worshiping in spirit, as the Lord said to the Samaritan woman."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN169",
      "id": "ap_NFIN169-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" Paul does not merely worship in spirit—he serves in spirit as well. For it is possible to worship without commitment, but to serve requires personal involvement. Therefore the apostle serves, not in body nor in soul but in the best part of him, i.e., in spirit. . . . The apostle always prefers the spirit and rejects the flesh and the things of the flesh. Similarly he praises the spirit of the law itself and rejects the letter as if it were flesh: “The letter kills, but the spirit gives life.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN170",
      "id": "ap_NFIN170-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("When Paul says that he prays without ceasing for those to whom he is writing, he is recalling his own instruction and practicing what he has preached."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN171",
      "id": "ap_NFIN171-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN172",
      "id": "ap_NFIN172-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERVING IN ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRIT.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("In order to encourage brotherly love, Paul gives God, whom he serves, as a witness, to whom he prays on their behalf, not in keeping the law but in the gospel of his Son, i.e., not in that which Moses the servant handed down but in that which the most beloved Son taught. For the servant is as far from his Lord as the gospel is from the law, not because the law is wrong but because the gospel is better. Therefore Paul serves God in the gospel of his Son in order to show that it is God’s will that men should believe in Christ.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Whom I serve.” How? In my spirit, says Paul, not in the circumcision made with hands, nor in new moons, nor in the sabbath or the choice of foods, but in the spirit, that is, in the mind. Because God is a spirit, it is right that he should be served in spirit or in the mind, for whoever serves him in his mind serves him in faith. This is what the Lord said to the Samaritan woman in John."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN173",
      "id": "ap_NFIN173-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" . . . He prays without ceasing for them, remembering them in his prayers in order to sow brotherly love among them; indeed, he makes this his desire for them. For who would not love someone when he hears that that person remembers him? For if they had willingly listened to the teaching brought to them in the name of Christ by those who were not sent, how much more would they want to listen to him who they knew was an apostle and whose words were accompanied by power! C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN174",
      "id": "ap_NFIN174-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRITUAL ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORSHIP.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORE OF ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OPSUESTIA: ")]), _vm._v("Paul rightly says “with my spirit,” contrasting this with the carnal worship of the Jews in circumcision and sabbatarianism and other such sacrifices, none of which is either spiritual or true. Some have pointed out that the phrase is a simpler way of saying “with my mind and with my will.” P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AULINE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY FROM THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN175",
      "id": "ap_NFIN175-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL OF ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IS ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("Why does Paul call God as his witness? He had to declare to the Romans all his feelings toward them, but he had not yet seen any of them. So he called no human witness but God who enters the heart. For he was saying “I love you,” and as evidence of that he mentioned that he was constantly praying for them. This was not self-evident either, so he had recourse to the most trustworthy testimony. Can any of you boast that, when praying at home, he remembers the entire body of the church? I doubt it. But Paul drew near to God on behalf not of one city only but of the whole world, and this not once, twice or three times but continually.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("When Paul says “whom I serve with my spirit in the Gospel of his Son,” he shows us both the grace of God and his own humility, the grace of God because he entrusted such a great task to "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Paul, and his own humility because Paul imputes it all not to his own zeal but to the help of the Spirit. The addition of “the gospel” shows what kind of ministry Paul had. For there are many different kinds of ministry . . . one man serves God and labors by believing and ordering his own life in the right way, another undertakes the care of strangers, and another takes care of those who are in need. Even in the apostle’s own time, Stephen’s colleagues served God by looking after widows, while others (including Paul) taught the Word and served in the preaching of the gospel.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN176",
      "id": "ap_NFIN176-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" This was the kind of ministry to which he was appointed.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Having spoken above about the gospel of the Father, Paul here says that it is the gospel of the Son. It makes no difference to call it the gospel of the Father or of the Son! Paul had learned from that blessed voice that the things of the Father are the Son’s, and the things of the Son are the Father’s. For: “all mine are yours and yours are mine.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN177",
      "id": "ap_NFIN177-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Praying for them without ceasing is the role of genuine love. Although Paul here seems to be saying only one thing, in fact he is saying four different things. First, he is saying that he remembers; second, that he does so continually; third, that he remembers in his prayers; and fourth, that he remembers to ask great things for them. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS 2.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN178",
      "id": "ap_NFIN178-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCEASING ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAYER.")])]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIUS: ")]), _vm._v("Paul serves God with his whole heart and with a ready zeal. . . . He also presents a model of unceasing prayer."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN179",
      "id": "ap_NFIN179-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIUS’S ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN180",
      "id": "ap_NFIN180-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RACE OF THE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRIT.")])]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENNADIUS OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONSTANTINOPLE: ")]), _vm._v("When Paul mentioned “his spirit,” he was not speaking about the person of the Spirit but about the grace of the Spirit which had been given to him to preach the gospel and by which, once he had been made worthy to be a coworker with God, he was enabled to carry out his work of mission. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AULINE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY FROM THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN181",
      "id": "ap_NFIN181-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-019"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('span', {
    staticClass: "r"
  }, [_c('i', [_vm._v("1:10")]), _vm._v(" Seeking God’s Will")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURNEYING ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CCORDING TO ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD’S ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILL.")])]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("When Paul says that he is praying that somehow and at some point he may have a successful journey, so that in the will of God he might come to Rome, it must be remembered that since the apostle of God is dedicated to a holy work, that is, to the work of the gospel, he is waiting until by his prayers not only may he have a journey which is successful but also that it might be successful according to the will of God. How much more therefore ought we, whose work and worth are so much less important, to ask God for success on our journey when we have some business to attend to!")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Nevertheless, I think that the apostle also wants us to understand that the success of a journey does not always mean that the journey is according to God’s will. For Balaam had a successful journey when he went to Balak in order to curse the people of Israel, but this success was not due to God’s will."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN182",
      "id": "ap_NFIN182-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" And many people have great success in worldly affairs and rejoice in their prosperity, but such prosperity is not of God’s will unless the purpose of our journey is to do his will, as the apostle says here. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN183",
      "id": "ap_NFIN183-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IS ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESIRE TO ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OME TO ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OME.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("Paul here indicates the point of his prayer for the Romans. He says that he asks God that he might come to Rome in order to encourage them with the will of God, whose gift he preaches. Then when he arrives and is present among them, if something has to be done, it may be done with the will of God. Therefore he prays that for whatever reason an opportunity may be given to him to come to the city, since he was already busy preaching to others, reckoning it a successful journey if he might come by God’s will, because the will of God has prepared the way. A success"), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("ful journey is not to endure the labor of traveling in vain. He asks that God will fill them by calling them to his grace. He speaks with eagerness of mind, for he desires their response, knowing that it will be to their mutual advantage. . . . For the apostle’s fruit is richer if it wins many. For since the joy is greater if the powerful people of this world are converted to Christ, because they are so much more serious enemies, even more are converted thereby, and the fruit of the apostle is richer if he can win many. Thus by God’s will the opportunity was given that Paul was arrested and appealed to Caesar, and was sent for a different reason to the city of Rome, by the will of God and in fulfillment of the desire of his will. For when Paul was shipwrecked, God appeared to him and said: “Do not be afraid, Paul. For as you have borne witness to me at Jerusalem, so also will you do at Rome.”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN184",
      "id": "ap_NFIN184-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN185",
      "id": "ap_NFIN185-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAY IN ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NSWERING ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAYER.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("You see how much Paul longed to see the Romans, but he did not want to see them if it was not God’s will, for his longing was tempered by the fear of God. . . . This is true love, not as our love, which tends to err in one direction or the other. Either we love no one, or if we do love, we love contrary to what seems good to God, and in both cases we go against the divine law. . . . For Paul to pray continually and not to give up even when he did not get what he prayed for shows very great love. But to love and yet at the same time to yield to the will of God shows deep reverence. . . . In this case Paul eventually got what he asked for but not when he asked for it, but this did not upset him. I mention all this so that we might not be upset at not being heard or at being heard only after some delay. For we are not better than Paul, who for good reason confesses that he is thankful in both circumstances. For once he had surrendered to the all-governing hand and submitted to it as far as he was able, like clay in the hand of the potter, he followed wherever God led. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS 2.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN186",
      "id": "ap_NFIN186-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERYTHING ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CCORDING TO ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD’S ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILL.")])]), _c('span', {
    staticClass: "small"
  }, [_vm._v(" [")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SEUDO-]")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONSTANTIUS: ")]), _vm._v("Paul shows that he does everything which he does according to the will of God. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLY ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER OF ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("T. ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN187",
      "id": "ap_NFIN187-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD’S ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRECTION.")])]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIUS: ")]), _vm._v("Paul does not find the way propitious unless the will of God, who knows all things, has directed him to a place where he might reap some fruit. For example, we read in Acts that, although he wanted to go to one place, he was directed to another."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN188",
      "id": "ap_NFIN188-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIUS’S ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN189",
      "id": "ap_NFIN189-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGING ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD’S ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILL.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YR: ")]), _vm._v("Paul does not simply say that he wants to come to Rome but adds that he wants to come in God’s will. For when the salvation of so many people was at stake, St. Paul left nothing unclear but acknowledged God’s will in his prayer, for it is only by God’s permission that we are worthy to deal with material things and to make choices. Do we not commit everything we have to the divine will on which we depend? I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTERPRETATION OF THE ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN190",
      "id": "ap_NFIN190-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-020"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('span', {
    staticClass: "r"
  }, [_c('i', [_vm._v("1:11")]), _vm._v(" Some Spiritual Gift")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MPARTING ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OME ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRITUAL ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFT.")])]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("First of all we must learn that it is an apostolic duty to seek fellowship with our brothers for no reason other than to share some spiritual gift with them if we can, or if we cannot, to receive some spiritual gift from them. Otherwise a desire to visit the beloved is hardly commendable. When Paul says “that I might impart to you some spiritual gift” he seems to imply that there is something which may be called a gift but which is not spiritual. For the gift of faith is undoubtedly spiritual, as is the gift of wisdom, of knowledge, of virginity. But when he speaks of marriage and of virginity, saying: “But each one has his own gift from God, some this one, "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("some that,”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN191",
      "id": "ap_NFIN191-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" he says that marriage is a gift, since it is written: “The woman was given to the man by God,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN192",
      "id": "ap_NFIN192-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" but this gift is not, strictly speaking, a spiritual gift. Many other things may also be called gifts of God, e.g., riches and bodily strength, physical beauty and earthly power. These things are also given by God, as Daniel says: “He removes kings and sets up kings,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN193",
      "id": "ap_NFIN193-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" but they are not spiritual gifts. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN194",
      "id": "ap_NFIN194-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD’S ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFT TO ")]), _vm._v("Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OU.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("This confirmation requires three persons: God, as helper; the apostle as minister and the people as receiver. Thus he now shows the will of his desire and what his wish for them is. For when he says: “that I might impart some spiritual gift to you,” he means that the Romans have followed carnal ideas, because in the name of Christ they have not followed what Christ taught but those things which had been handed down to them by the Jews. But he wants to come to them as quickly as possible in order to take them beyond that tradition and bestow on them a spiritual gift, that he might win them for God, making them partakers of spiritual grace, that they might be perfect in faith and behavior. From this we learn that he had not praised the content of their faith in the preceding verses but their readiness and devotion to Christ. For calling themselves Christians, they acted just as if they were under the law, as that had been handed down to them. For the mercy of God had been given for this reason, that they should cease from the works of the law, as I have often said, because God, taking pity on our weakness, decreed that the human race would be saved by faith alone, along with the natural law.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("When he admonishes them in writing and draws them away from carnal thoughts, when he says that his presence is necessary in order to impart a spiritual grace to them, what does this mean? Isn’t what he writes also spiritual? He does not want his teaching to be applied in a way he does not intend, for that is what happens with heretics. So he desires to be present with them and pass on to them the gospel teaching in the precise sense in which he writes it, lest by the authority of his letter their error should be confirmed and not removed. If he were with them he would be able to convince them by power, if words failed to persuade them. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN195",
      "id": "ap_NFIN195-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IS ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RESENCE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EQUIRED IN ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MPARTING THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFT.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORE OF ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OPSUESTIA: ")]), _vm._v("Paul showed by his longing to see them that his desire was genuine, and by his eagerness to share, that the Romans’ spiritual gift was not something private but that he himself would be the one who would impart it. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AULINE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY FROM THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN196",
      "id": "ap_NFIN196-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HARACTER OF ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EACHING.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("Paul did not travel for no reason, as so many do nowadays, but for a specific and very urgent purpose. And he does not tell them his meaning openly but rather hints at it, for he does not say: “that I may teach you, that I may instruct you, that I may fill up that which is wanting,” but: “that I may impart this spiritual gift,” showing that it was not his own things which he was giving them but what he had himself received. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS 2.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN197",
      "id": "ap_NFIN197-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONFIRMING ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETER’S ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REACHING.")])]), _c('span', {
    staticClass: "small"
  }, [_vm._v(" [")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SEUDO-]")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONSTANTIUS: ")]), _vm._v("Paul says that he wants to strengthen the Romans, who held their faith from the preaching of Peter, not because they had received something inferior from Peter but that their faith would be strengthened by the witness and teaching of both apostles. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLY ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER OF ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("T. ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN198",
      "id": "ap_NFIN198-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HARING ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AS ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECEIVED.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YR: ")]), _vm._v("These words are full of humility. . . . Paul only wants to share what he has himself received. And because the great Peter was the "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("first to have taught them, Paul adds that he merely wants to confirm them in the teaching which has already been given to them and to water the trees which have already been planted. Once again, his speech is full of modesty. I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTERPRETATION OF THE ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN199",
      "id": "ap_NFIN199-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-021"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('span', {
    staticClass: "r"
  }, [_c('i', [_vm._v("1:12 ")]), _vm._v("Encouragement in the Faith")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCOURAGING ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACH ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("THER’S ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH.")])]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("Those on whom the apostle wishes to bestow spiritual grace for the encouragement of their faith, so that they will no longer be children, nor tossed about by every wind of doctrine"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN200",
      "id": "ap_NFIN200-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v("—they are the truly blessed. Paul himself received comfort from seeing his work firm and stable, and they are comforted because they share in the apostolic grace. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN201",
      "id": "ap_NFIN201-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMFORT IN THE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AME ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("Paul says that he will be comforted with them insofar as they come to understand spiritual things. Even while he may rejoice in their faith, he nevertheless grieves insofar as they have not received the faith rightly. The apostle was the type to grieve for the faults of others as if they were his own. “And we are comforted by this,” he says, “by one and the same faith.” In this way the act of comforting is seamless. For it is by the unity of faith that they are brought to maturity in Christ. By this means the ministry of spiritual grace is given through the apostle’s preaching of the gospel and produces its own fruit. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN202",
      "id": "ap_NFIN202-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WN ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EED FOR ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMFORT.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("POLLINARIS OF ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AODICEA: ")]), _vm._v("Even Paul was not above the need of comfort. For right speech comforts the speaker as well. By this means Paul is teaching his followers not to be proud if they are called to teach. They are not giving what merely belongs to them when they teach. They come to realize that they not only minister to others’ needs but that they have needs themselves. For this is the fruit of the gospel. It is a blessing to those who preach it. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AULINE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY FROM THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN203",
      "id": "ap_NFIN203-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ULL ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("QUALITY. ")])]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("The Romans were undergoing many tribulations. Paul wanted to see them in order to comfort them and also to be comforted by them. . . . What humility he had! He showed them that he needed them as much as they needed him. By doing this, he put learners in the position of teachers, not claiming any superiority for himself but pointing out that they were fully equal to him.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Now if anyone should say that Paul’s comfort was his gladness at the increase of the Romans’ faith and that Paul needed this, he would not be mistaken. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS 2.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN204",
      "id": "ap_NFIN204-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVE AND TO ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECEIVE.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YR: ")]), _vm._v("Paul wanted to receive as well as to give. The eagerness was on both sides. I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTERPRETATION OF THE ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN205",
      "id": "ap_NFIN205-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFLECTING THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HARGE OF ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RESUMPTION.")])]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENNADIUS OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONSTANTINOPLE: ")]), _vm._v("Paul says this for fear of tripping up his hearers, who might not have known what to say to the prospect of sharing in some spiritual gift. For what could have been lacking in the teaching of Peter? Paul might be accused of criticizing Peter’s teaching . . . of thinking that he was a greater apostle than Peter, of claiming to be on closer terms with Christ and more beloved by Christ than Peter was. Fearing attacks of this kind, Paul first of all sets out the purpose of his coming, thereby sufficiently refuting the charge of presumption. Then he goes on to say not that he is giving them something but that he is going to share something with them, which is quite different. . . . Paul reassures them that he has no intention of preaching anything new to them but that he intends to confirm them "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("in what they have already received from Peter. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AULINE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY FROM THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN206",
      "id": "ap_NFIN206-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-022"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('span', {
    staticClass: "r"
  }, [_c('i', [_vm._v("1:13 ")]), _vm._v("Divine and Human Plans")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EALING WITH ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INDRANCES.")])]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("This sentence contains a rhetorical aside "), _c('i', [_vm._v("(hyperbaton),")]), _vm._v(" and the construction is defective. . . . It ought to be joined to the next verse by the words “to whom,” so that the phrase reads: “the rest of the Gentiles, Greeks and barbarians, to whom I am under obligation.” . . .The whole thing would then read as follows: “Just as I have fruit among the other Gentiles, Greeks and barbarians, wise and foolish, to whom I am under obligation, so also, as much as in me lies, am I eager to preach the gospel also to you who are at Rome, for I am not ashamed to preach the gospel among any people, for the power of God is in it for salvation to all who believe, for the Jew first and for the Greek, for in the gospel the righteousness of God is revealed, which was previously covered by a veil in the law. Now it is revealed in those who come from the faith of the Old Testament to the faith of the new gospel.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("So much for the order of the words; now we must examine the apostle’s meaning. When Paul says: “I have often intended to come to you,” he demonstrates the love which he had for the Romans. But when he adds: “but thus far have been prevented,” though indeed it may be thought that he was prevented by God, it is shown by this that it is God’s business where each of the apostles ought or ought not to go. It is by a particular dispensation that he appoints some to preach the Word of God and others not, as Paul himself says elsewhere: “When we tried to go into Bithynia, the Spirit of Christ prevented us.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN207",
      "id": "ap_NFIN207-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" . . . But if this phrase refers to the passage where he says that: “Satan hindered us,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN208",
      "id": "ap_NFIN208-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" he shows clearly that he is constantly struggling in prayer, so that by overcoming the hindrances of Satan he may be given a successful journey in the will of God, to see those who are at Rome.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("For he desires and does not cease to pray that he may obtain some fruit from them as he has from the other Gentiles. Thus like one who is acquisitive for many riches, Paul wants to amass some return from his many spiritual investments. He gathers fruit from the Greeks, fruit from the barbarians, fruit from the wise, fruit even from the foolish. For while to some he speaks wisdom as to those who are perfect, to others he says, as if speaking to foolish people, that he wants to know nothing among them except Jesus Christ and him crucified."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN209",
      "id": "ap_NFIN209-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" Some he teaches from the law and the prophets; others he persuades with signs and wonders. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN210",
      "id": "ap_NFIN210-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("I H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVE ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FTEN ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTENDED. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("Paul here indicates his plan and intention, which he does not doubt that they already know from those brothers who had come to Rome from Jerusalem or the neighboring cities for some reason, perhaps because of their religion, or from Aquila and Priscilla, who would have told the Romans of Paul’s intention."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN211",
      "id": "ap_NFIN211-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" As he had often wanted to come but had been prevented, it came about that he wrote them a letter, lest they continue in their unwholesome habits for too long to be easily corrected. He calls them brothers not only because they had been born again but also because there were among them some who believed rightly, however few they may have been. Incidentally, this is why he says that they are “called to be saints.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN212",
      "id": "ap_NFIN212-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" What does it mean to be called to be saints? If they are already saints, how can they be called to be sanctified? This belongs to the foreknowledge of God, because God knows those who will be saints, for those who are already with him are saints and remain called forever. Yet Paul says that he has been prevented up to the time the epistle was written. He was being prevented by God, who could foresee that the Romans were still unpre"), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("pared. So God sent the apostle to other cities more prepared to receive the truth.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("While acting in the name of the Savior, they were still prevented by their negligence from being as yet worthy to learn spiritual things.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Paul did not say that he was prevented for no reason. He wanted them to know why he was delayed. He urged them to get ready, so that when they heard that a spiritual grace was to be given to them they would make themselves ready to receive it.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Paul declares that he wants to come to them for their common good, so that they might receive the saving grace of the Spirit, having a reasoned profession of their faith, and that he might have some fruit of his ministry from God, having provoked them to the right faith by the example of the other Gentiles. For one who sees others responding in faith will be more eager to receive it. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN213",
      "id": "ap_NFIN213-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARVEST ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MONG ")]), _vm._v("Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OU.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("POLLINARIS OF ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AODICEA: ")]), _vm._v("For the fruit of those who have believed the Word is the benefit to those who hear it. And the Lord says that he has sent the apostles in order to bear much fruit."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN214",
      "id": "ap_NFIN214-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" Indeed, a few gleaners have harvested the entire church. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AULINE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY FROM THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN215",
      "id": "ap_NFIN215-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FTEN ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REVENTED.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORE OF ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OPSUESTIA: ")]), _vm._v("Paul here shows quite clearly that he wanted to go to Rome but that he had often been prevented. At the same time he wants to put them in fear, lest perhaps it was because of their unworthiness that he had been prevented from going to them. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AULINE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY FROM THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN216",
      "id": "ap_NFIN216-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ODLY ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTIVE.")])]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVERIAN: ")]), _vm._v("There were many who sped to Rome for human reasons. Paul reveals his own chaste desire to go there and that his motive was a godly one. It appears that he longed after the Romans, perhaps because their faith had become an encouragement to all their subject peoples. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AULINE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY FROM THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN217",
      "id": "ap_NFIN217-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IELDING TO ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROVIDENCE.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("Here is an obedience as great as that of slaves and a clear demonstration of Paul’s excellent temper. He says he was prevented from coming to them but does not explain why. For he does not pry into the command of his master but simply obeys. And yet one might expect someone to wonder why God prevented a city as conspicuous and great as Rome . . . from enjoying such a teacher, and for such a long time as well. . . . But Paul does not concern himself with such things, yielding instead to the incomprehensible nature of providence. By doing this he shows the right tone of his soul and also teaches us never to call God to account for what happens, even though what is done seems to trouble the minds of many. For it is the master’s place to command and the servant’s to obey. This is why he says that he was prevented without giving the reason, because he did not know it himself. . . . So if you do not know why something has happened, do not be discouraged, for this is a main feature of faith, to receive what is told to us of God’s providence even when we are ignorant of the way in which it is being dispensed. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS 2.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN218",
      "id": "ap_NFIN218-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LANS. ")])]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIUS: ")]), _vm._v("The Romans would have learned of Paul’s plans through the brothers who were constantly coming and going. "), _c('i', [_vm._v("Prevented")]), _vm._v(" here means “busy,” because he was preaching in other provinces. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIUS’S ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN219",
      "id": "ap_NFIN219-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD’S ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERRULING. ")])]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YR: ")]), _vm._v("Paul declares both his own plan and God’s overruling. For God’s grace was fully in control of his life. I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTERPRETATION OF THE ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN220",
      "id": "ap_NFIN220-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENEFITS OF THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL. ")])])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENNADIUS OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONSTANTINOPLE: ")]), _vm._v("Paul tells the Romans that it will benefit him to come to them, saying that the nations which received the gospel through him had clearly added to his own riches. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AULINE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY FROM THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN221",
      "id": "ap_NFIN221-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09aa1e8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap2.vue
// module id = 84
// module chunks = 0